<div class="flex justify-content-between fixed p-2 bg-white mt-8 mr-4 shadow-3 top-0 right-0 z-5"
     style="min-height: 90vh; max-width: 45rem;">
    <!--sign task details info field begin-->
    <div class="w-full h-full" *ngIf="!detailedData.signProcess">
        <p-skeleton height="75vh" class="w-full" styleClass="w-full"></p-skeleton>
    </div>

    <div class="w-full p-1 flex flex-column" *ngIf="detailedData.signProcess">
        <div class="border-0">
            <div class="flex justify-content-between">
                <h2>{{ 'sipo.document-signing-component.signature-details' | translate }}</h2>
                <i class="pi pi-times cursor-pointer text-2xl font-bold text-red-500" (click)="close()"></i>
            </div>
            <div>

                <button class="p-button flex justify-content-center my-5 py-4 w-12" (click)="navigateToSign()"
                        *ngIf="!signState">
                    {{ 'sipo.document-signing-component.sign-the-document' | translate }}
                </button>


                <div
                    class="p-button bg-transparent text-lg font-bold text-gray-500 flex justify-content-center my-5 py-4 w-12"
                    *ngIf="signState">
                    {{ 'sipo.document-signing-component.you-already-signed-the-document' | translate }}
                </div>
            </div>
            <p>&nbsp;</p>

            <div class="flex align-items-center w-full mb-3">
                <p class="mr-3"><strong>{{ 'sipo.signing-type' | translate }}:</strong></p>
                <div class="w-4" [innerHTML]="(detailedData.signProcess.signingType) | evidenceSvg"></div>
            </div>

            <p><strong>{{ 'sipo.message' | translate }}
                :</strong> {{ detailedData.signProcess.message ? detailedData.signProcess.message : 'sipo.document-signing-component.no-observer' | translate }}
            </p>
            <p><strong>{{ 'sipo.observers' | translate }}
                :</strong> {{ detailedData.signProcess.observers ? detailedData.signProcess.observers : 'sipo.document-signing-component.no-observer' | translate }}
            </p>


            <h5>{{ 'sipo.signers' | translate }}:</h5>
            <ul>
                <li class="py-1"
                    *ngFor="let signer of detailedData.signProcess.signers">
                    {{ signer.fullName }} ({{ signer.email }})
                    <span *ngIf="signer.isCreator"
                          class="no-line-break"> {{ 'sipo.document-signing-component.initiator' | translate }}</span>
                </li>
            </ul>

            <h5>{{ 'sipo.sign-component.final-component.additional-files' | translate }}</h5>
            <ul class="justify-content-center my-5 pw-3 w-12" *ngIf="detailedData.signProcess.additionalFiles"
                style="overflow-x: hidden !important; padding-bottom: 1rem;: ">
                <li *ngIf="detailedData.signProcess.additionalFiles?.length === 0">
                    {{ 'sipo.document-signing-component.no-additional-file' | translate }}
                </li>
                <li *ngFor="let file of detailedData.signProcess.additionalFiles">
                    <a href="#" class="no-line-break">
                        {{ file.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <!--sign task details info field end-->
</div>
